import { CookiesStorageService } from '@/services/cookiesStorageService';
import { generateUrlParams } from '@/helpers/generateUrlParams';
import { COOKIES_KEYS } from '@/constants';

type TGetRnDValue = () => boolean;
export const getRnDValue: TGetRnDValue = () => {
	const { RnD } = generateUrlParams<Record<string, string>>();

	let RnDFlag: boolean;

	try {
		RnDFlag = JSON.parse(RnD?.toLowerCase() ?? 'false');
	} catch (error) {
		RnDFlag = false;
	}
	return CookiesStorageService.get(COOKIES_KEYS.RND_FB_PIXEL, RnDFlag);
};
